import React, { useState, useEffect, useContext, useRef } from "react";
import { PostApi } from "../api/api-service";
import { API_Path, numRegex } from "../Const";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import DropdownComponent from "../components/dropdown/DropdownComponent";
import DropdownPropertys from "../components/dropdown/DropdownPropertys";
import DropdownMulti from "../components/dropdown/DropdownMulti";
import ImagesModal from "../components/modal/ImagesModal";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import ContectModal from "../components/modal/ContectModal";
import CommonPagination from "../components/CommonPagination";
import PropertySection from "../components/property/PropertySection";
import { AuthContext } from "../context/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import noDataFound from "../images/noDataFound.png";
import { StoreContext } from "../context/StoreContext";
import AutoMultiSearch from "../components/CustomizedHook/AutoMultiSearch";
import PropertiesLoader from "../components/loader/PropertiesLoader";
import { rentFqcyARY } from "../components/CommonFun";
import MoreFilters from "../components/dropdown/MoreFilters";
// import PrtyFilter from "../components/PrtyFilter";

function Property() {
    const { completionType, fetchCompletionType, purposeType, fetchPurposeType, categoriesType, fetchCategoriesType, cityData, fatchCity } = useContext(AuthContext);
    const { localityData, fatchLocality } = useContext(StoreContext);
    const navigate = useNavigate();
    const paramID = useParams();
    const location = useLocation();
    const [ltsProperties, setLtsProperties] = useState([]);
    const [isLoader, setIsLoader] = useState(true);
    const [serLoader, setSerLoader] = useState({ serach: false, reset: false });
    const [propertyImgsmdl, setPropertyImgsmdl] = useState([]);
    const [imgModalShow, setImgModalShow] = useState(false);
    const [emailModalShow, setEmailModalShow] = useState(false);
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(24);
    const [totalPages, setTotalPages] = useState(1);
    const [bannerFilter, setFilterData] = useState({
        purpose: "sale",
        categorySlug: "Residential",
        categoryName: [],
        categories: [],
        bedRooms: [],
        baths: [],
        minPrice: "",
        maxPrice: "",
        location: "",
        completion: "all",
        minArea: "",
        maxArea: "",
        locality: "",
        rent_frequency: "",
        city: "",
    });
    const [filterTitle, setFilterTitle] = useState("Properties for sale in UAE");
    const [combinedData, setCombinedData] = useState([]);
    const loaders = Array.from({ length: 8 });
    const hasFetched = useRef(false);
    useEffect(() => {
        if (hasFetched.current) return;
        const locationdata = location?.pathname?.split("/");
        const params = new URLSearchParams(locationdata[3]);
        // const params = new URLSearchParams(window.location.search);
        let splitData = paramID?.listingType?.split("-");
        let findListingType = purposeType.find((item) => item?.type === splitData[1]);
        const parsedFilters = {
            purpose: findListingType?.type,
            categorySlug: "Residential",
            categoryName: [],
            categories: params.get("categories")?.split("%2") || [],
            bedRooms: params.get("bed")?.split(",") || [],
            baths: params.get("bath")?.split(",") || [],
            minPrice: parseInt(params.get("price_min"), 10) || 0,
            maxPrice: parseInt(params.get("price_max"), 10) || 0,
            location: "",
            completion: params.get("completion") || "all",
            minArea: parseInt(params.get("area_min"), 10) || 0,
            maxArea: parseInt(params.get("area_max"), 10) || 0,
            locality: params.get("locality") || "",
            rent_frequency: params.get("rent_frequency") || "",
            city: params.get("city") || "",
        };
        setFilterData(parsedFilters);
        const isData = Object.values(parsedFilters).every((value) => value?.length === 0 || value === "" || value === 0);
        if (!isData && purposeType.length > 0) {
            hasFetched.current = true;
            fechLtsProperties(1, parsedFilters);
        }
    }, [location.pathname, purposeType]);

    useEffect(() => {
        const updatedCityData = cityData.map((city) => ({ name: city.cityName, Keyname: "city" }));
        const updatedLocalityData = localityData.map((locality) => ({ name: locality.name, Keyname: "locality" }));
        const combined = [...updatedCityData, ...updatedLocalityData];
        setCombinedData(combined);
    }, [localityData, cityData]);

    useEffect(() => {
        topRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [currentPage]);

    useEffect(() => {
        fetchCategoriesType();
        fetchPurposeType();
        fatchLocality();
        fatchCity();
        fetchCompletionType();
    }, []);

    const filterCallBack = (option, name) => {
        let newFilterData = bannerFilter;
        // let newFilterData = { ...bannerFilter };
        newFilterData[name] = option;
        if (name === "minPrice" || name === "maxPrice" || name === "minArea" || name === "maxArea") {
            if (option != 0) {
                if (/^0/.test(option)) option = option.replace(/^0+/, "");
                if (numRegex.test(option)) setFilterData({ ...bannerFilter, [name]: option });
            } else setFilterData({ ...bannerFilter, [name]: "" });
        } else if (name === "completion") setFilterData({ ...bannerFilter, [name]: option });
        else setFilterData(option);
        // if(option == "all") filterReset();
    };

    const fechLtsProperties = async (page, item) => {
        let option = `/pagination?pageNumber=${page}&pageSize=${pageSize}`;
        let data = {
            categoryName: item?.categories?.length > 0 ? item?.categories : null,
            bedRooms:
                item?.bedRooms?.length > 0
                    ? item.bedRooms
                          .map((bed) => (bed === "Studio" ? 0 : Number(bed)))
                          .filter((bed) => !Number.isNaN(bed))
                          .sort((a, b) => a - b)
                    : null,
            bathRooms: item?.baths?.length > 0 ? item?.baths : null,
            minArea: item?.minArea ? parseInt(item?.minArea) : null,
            maxArea: item?.maxArea ? parseInt(item?.maxArea) : null,
            minPrice: item?.minPrice ? parseInt(item?.minPrice) : null,
            maxPrice: item?.maxPrice ? parseInt(item?.maxPrice) : null,
            purposeType: item?.purpose ? item?.purpose.toLowerCase() : null,
            completionType: item?.purpose === "sale" ? (item?.completion ? (item.completion !== "all" ? item.completion.toLowerCase() : null) : null) : null,
            rentFrequency: item?.purpose === "rent" ? (item?.rent_frequency !== "any" ? item?.rent_frequency : null) : null,
            country: "",
            state: "",
            city: item?.city ? item?.city : null,
            locality: item?.locality ? item?.locality : null,
        };
        let cleanedData = Object.fromEntries(Object.entries(data).filter(([key, value]) => value !== null && value !== undefined && value !== "" && !(Array.isArray(value) && value.length === 0)));
        try {
            setIsLoader(true);
            let res = await PostApi(API_Path.propertiesDetails + option, { data: cleanedData });
            if (res && res.data.success) {
                setLtsProperties(res.data.data);
                setCurrentPage(res.data.currentPage);
                setPageSize(res.data.pageSize);
                setTotalPages(res.data.totalPages);
            }
            setSerLoader({ serach: false, reset: false });
            setIsLoader(false);
        } catch (error) {
            setSerLoader({ serach: false, reset: false });
            setIsLoader(false);
        }
    };
    const formatProperties = (properties) => {
        const limit = 3;
        if (properties.length <= limit) {
            return properties.join(", ").replace(/,([^,]*)$/, " and$1");
        } else {
            const displayedItems = properties.slice(0, limit);
            return `${displayedItems.join(", ")} and ${properties.length - limit} more`;
        }
    };
    const handlesearch = () => {
        setSerLoader({ serach: true, reset: false });
        navigate(buildSearchUrl());
        // var title;
        // if (bannerFilter?.completion === "offplan") {
        //     title = `Off-Plan ${bannerFilter?.categories.length > 0 ? formatProperties(bannerFilter?.categories) : "Properties"} in ${bannerFilter?.locality ? bannerFilter?.locality : "UAE"}`;
        // } else if (bannerFilter?.completion === "ready") {
        //     title = `${bannerFilter?.categories.length > 0 ? formatProperties(bannerFilter?.categories) : "Properties"} for sale in ${bannerFilter?.locality ? bannerFilter?.locality : "UAE"}`;
        // }
        // setFilterTitle(title);
        fechLtsProperties(1, bannerFilter);
    };
    const filterReset = () => {
        navigate(buildSearchUrl());
        fechLtsProperties(1, bannerFilter);
    };

    const handleReset = () => {
        navigate("/property/for-sale");
        let data = {
            purpose: "sale",
            categorySlug: "Residential",
            categoryName: [],
            categories: [],
            bedRooms: [],
            baths: [],
            minPrice: "",
            maxPrice: "",
            location: "",
            completion: "all",
            maxArea: "",
            minArea: "",
            rent_frequency: "",
            city: "",
        };
        setSerLoader({ serach: false, reset: true });
        setFilterData(data);
        fechLtsProperties(1, data);
    };
    console.log(bannerFilter ,"bannerFilter")
    const handleClose = () => {
        setImgModalShow(false);
        setPropertyImgsmdl([]);
    };
    const handleModalHide = () => setEmailModalShow(false);
    const handlePhoneModalHide = () => setPhoneModalShow({ ...phoneModalShow, show: false });
    const topRef = useRef(null);
    const tableCallBack = async (page) => {
        await fechLtsProperties(page, bannerFilter);
    };

    const buildSearchUrl = () => {
        let url = `/property/${bannerFilter.purpose?.toLowerCase() === "rent" ? "to-rent" : "for-sale"}`;
        let firstParamAdded = true;
        const add = (key, value) => {
            if (!value || (Array.isArray(value) && value.length === 0)) return;
            url += `${firstParamAdded ? "/" : "&"}${key}=${encodeURIComponent(Array.isArray(value) ? value.join(",") : value)}`;
            firstParamAdded = false;
        };
        if (bannerFilter?.categories?.length > 0) add("categories", bannerFilter?.categories?.length > 0 ? bannerFilter?.categories.join("%2") : "");
        add("completion", bannerFilter.purpose === "sale" ? (bannerFilter.completion !== "all" ? bannerFilter.completion : "") : "");
        add("rent_frequency", bannerFilter.purpose === "rent" ? (bannerFilter.rent_frequency !== "any" ? bannerFilter.rent_frequency : "") : "");
        add("price_min", bannerFilter.minPrice);
        add("price_max", bannerFilter.maxPrice);
        add("area_min", bannerFilter.minArea);
        add("area_max", bannerFilter.maxArea);
        add("bed", bannerFilter.bedRooms && bannerFilter.bedRooms.length > 0 ? bannerFilter.bedRooms : "");
        add("bath", bannerFilter.baths && bannerFilter.baths.length > 0 ? bannerFilter.baths : "");
        add("city", bannerFilter.city);
        add("locality", bannerFilter.locality);
        return url;
    };

    return (
        <>
            <div className="property-dropdown">
                <div className="container">
                    <div className="pety_bg">
                        <div className="hero-dropdown-sec filter_fropdown">
                            {purposeType?.length > 0 && <DropdownComponent name="Buy" kName="purpose" option={purposeType} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />}
                            <AutoMultiSearch
                                data={combinedData}
                                filterData={bannerFilter}
                                filterCallBack={filterCallBack}
                                kName="name"
                                plshdr="Enter location"
                                multiShow={false}
                                handleReset={handleReset}
                                isIcon={true}
                                // filterReset={filterReset}
                            />
                            {bannerFilter?.purpose?.toLowerCase() === "sale" ? (
                                <div className="buy-tab-btn property-buy-tab">
                                    <div className="tab-buttons">
                                        <button className={`tab-btn${bannerFilter.completion === "all" ? " active" : ""}`} onClick={() => filterCallBack("all", "completion")}>
                                            All
                                        </button>
                                        {completionType &&
                                            completionType.length > 0 &&
                                            completionType.map((item, i) => (
                                                <button key={i} className={`tab-btn${bannerFilter.completion === item?.type ? " active" : ""}`} onClick={() => filterCallBack(item.type, "completion")}>
                                                    {item?.name}
                                                </button>
                                            ))}
                                    </div>
                                </div>
                            ) : (
                                <DropdownComponent name="yearly" kName="rent_frequency" option={rentFqcyARY} bannerFilter={bannerFilter} filterCallBack={filterCallBack} handlesearch={handlesearch} />
                            )}
                            {categoriesType?.length > 0 && (
                                <div className="dropdown">
                                    <DropdownPropertys categoriesType={categoriesType} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                                </div>
                            )}
                            {bannerFilter?.categorySlug === "Residential" && <DropdownMulti name="Beds & Baths" bannerFilter={bannerFilter} filterCallBack={filterCallBack} />}
                            <MoreFilters plchdlr="Price (AED)" filterData={bannerFilter} filterCallBack={filterCallBack} minKey="minPrice" maxKey="maxPrice" />
                        </div>
                        <div className="dropdown-footer">
                            {(bannerFilter.baths.length > 0 ||
                                bannerFilter.bedRooms.length > 0 ||
                                bannerFilter.categories.length > 0 ||
                                bannerFilter.city != "" ||
                                bannerFilter.locality != "" ||
                                bannerFilter.completion != "all" ||
                                bannerFilter.rent_frequency != "" ||
                                bannerFilter.minPrice != "" ||
                                bannerFilter.minPrice != 0 ||
                                bannerFilter.maxPrice != "" ||
                                bannerFilter.maxPrice != 0 ||
                                bannerFilter.minArea != "" ||
                                bannerFilter.minArea != 0 ||
                                bannerFilter.maxArea != "" ||
                                bannerFilter.maxArea != 0) && (
                                <>
                                    <button className="button reset_btn me-2" onClick={handleReset} disabled={serLoader.reset}>
                                        Reset
                                    </button>
                                </>
                            )}
                            <button className="button search_btn" onClick={handlesearch} disabled={serLoader.serach}>
                                Search
                                {serLoader.serach && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-block">
                <div className="container">
                    {isLoader ? (
                        <div className="row slider-section info-block ">
                            {loaders.map((_, index) => (
                                <div className="info-block-inner " key={index}>
                                    <PropertiesLoader />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <>
                            <h1 className="heroTitle">{filterTitle}</h1>
                            {ltsProperties.length > 0 ? (
                                <>
                                    <div className="our-latest-sec">
                                        <PropertySection ltsProperties={ltsProperties} />
                                    </div>
                                    <CommonPagination currentPage={currentPage} pageSize={pageSize} totalPages={totalPages} tableCallBack={tableCallBack} />
                                </>
                            ) : (
                                <div className="content_notfound">
                                    <img src={noDataFound} alt="No results matching your search" />
                                    <h3>No results matching your search.</h3>
                                    <p>You could try to remove some filters.</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            {/* modal */}
            {imgModalShow && <ImagesModal show={imgModalShow} handleHide={handleClose} propertyImgsmdl={propertyImgsmdl} />}
            {emailModalShow && <EmailAgentModal show={emailModalShow} onHide={handleModalHide} pData={ltsProperties} type="property" />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
        </>
    );
}

export default Property;
